import { isEmptyArray } from '../objects/isEmpty';

export function removeValue<T>(array: T[], value: T): T[] {
	// Nothing in the array
	if (isEmptyArray(array)) {
		return [];
	}

	// Remove it from the array
	return array.filter((arrayValue) => arrayValue !== value);
}
